import React from 'react';
import Marquee from "react-fast-marquee";
import './marquee.css';
import { mothersday, kishorkumar } from './imports';


const marquee = () => {
  return (
    <div className='gpt3__marquee-component'>
      <Marquee pauseOnHover={true} speed={40} gradient={false}>

          <div className='gpt3__marquee-component-content'>
          <img className="gpt3__marquee-image" src={kishorkumar} alt="Happy Birthday to Kishore Kumar"/>
          <div className='gpt3__marquee-component-text'>
          Happy 97th Birthday to Kishore Kumar</div>
          <img className="gpt3__marquee-image" src={kishorkumar} alt="Happy Birthday to Kishore Kumar"/>
          </div>
          
        </Marquee>
    </div>
  )
}


export default marquee
